import type {IFaqQuestion} from "../types/IFaqQuestion";

interface IProps {
    questions: IFaqQuestion[];
}

export const FaqSchema = (props: IProps) => {
    const json = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: props.questions.map((question) => ({
            "@type": "Question",
            name: question.name,
            acceptedAnswer: {
                "@type": "Answer",
                text: question.answer_text
            }
        }))
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
import type {IFaqQuestion} from "../types/IFaqQuestion";

interface IProps {
    questions: IFaqQuestion[];
}

export const FaqSchema = (props: IProps) => {
    const json = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: props.questions.map((question) => ({
            "@type": "Question",
            name: question.name,
            acceptedAnswer: {
                "@type": "Answer",
                text: question.answer_text
            }
        }))
    };

    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(json)}} />;
};
